// Simple email regexp
var EMAIL_REGEXP = /^\S+@\S+\.\S+$/;
var validEmail = function validEmail(_a) {
  var _b = _a === void 0 ? {} : _a,
    _c = _b.message,
    message = _c === void 0 ? 'Введите корректный e-mail' : _c,
    _d = _b.emptyMessage,
    emptyMessage = _d === void 0 ? 'Введите e-mail' : _d,
    _e = _b.required,
    required = _e === void 0 ? true : _e;
  return function (value) {
    if (!value || !value.trim()) {
      return required ? emptyMessage : undefined;
    }
    return EMAIL_REGEXP.test(value) ? undefined : message;
  };
};
export { EMAIL_REGEXP, validEmail };